/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  configure-wireless-reducer.ts
 *
 * Project Title :  Checkout
 *
 * Description	 :
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Suresh Jaladi (E807958)
 *
 * @Date	     : 05 November 2019
 *
 * @Version      : Version 1.0
 *
 * By            : E844276
 * On            : Nov 18, 2019
 * Description   : Added generic product functionalities - removed from products
 *
 * By            : E807958
 * On            : Nov 21, 2019
 * Description   : ASDS-1801, ASDS-1802, ASDS-1803, ASDS-1804
 *
 * By           : H224423
 * On           : Nov 28, 2019
 * Description  : ASDS-1474 Accept product terms changes.
 *
 * By            : Deepthi Bachu - E844276
 * On            : 28 Nov, 2019
 * Description   : ASDS-1953
 *
 * By            : H224423
 * On            : 12 Dec, 2019
 * Description   : Terms Checkbox default checked issue fix.
 *
 * By             : H422337
 * On             : Sep 07,2020
 * Description    : ASDS-2570 UI enhancements as part of phase-2
 *
 * By            : H422337
 * On            : Oct 27, 2020
 * Description   : ASDS-3555 - UI Enhancements for Phase - II -migrate to Forge API
 *
 ******************************************************************************/

import Reducer from './reducer';
import { AsdsReduxAction, AsdsReducerObject } from '../../../../types';
import { createReducer } from '../utils/redux-util';
import ActionConstants from '../action-constants';


class ConfigureWirelessProductReducer extends Reducer {
    static onClickWirelessAddToCartButton(state, action: AsdsReduxAction) {
        return {
            payload: {
                ...state.payload,
                configureWirelessModelOpen: action.payload.configureWirelessModelOpen,
                product: action.payload.product,
                system: action.payload.system,
                categoryName: action.payload.categoryName,
            }
        };
    }

    static setProductsInCart(state, action: AsdsReduxAction) {
        return {
            payload: {
                ...state.payload,
                productsInCart: action.payload.productsInCart,
            }
        };
    }

    static resetWirelessConfiguration(state) {
        return {
            payload: {
                ...state.payload,
                activeTab: 1,
                enableNextBtn: false,
                configureWirelessModelOpen: false,
                acceptTermsStatus: false,
                acceptTermsErrorMsg: '',
                product: {},
                system: '',
                aircraftDetailsArray: [
                    {
                        aircraftType: '',
                        aircraftTypeError: '',
                        serialNumber: '',
                        serialNumberError: '',
                        tailNumber: '',
                        tailNumberError: '',
                        price: 0.00,
                    }
                ],
                editWirelessProductDetails:{
                    productSeq: 0,
                    id: 0,
                    seq: 0,
                    cartSeq: 0
                }
            }
        };
    }

    static wirelessBackButtonHandle(state, action: AsdsReduxAction) {
        return {
            payload: {
                ...state.payload,
                activeTab: action.payload.activeTab,
                enableNextBtn: action.payload.enableNextBtn
            }
        };
    }

    static gotoWirelessConfirmConfig(state, action: AsdsReduxAction) {
        return {
            payload: {
                ...state.payload,
                activeTab: action.payload.activeTab,
            }
        };
    }

    static addWirelessAircraft(state, action: AsdsReduxAction) {
        return {
            payload: {
                ...state.payload,
                aircraftDetailsArray: action.payload.updatedAircraftsData,
                enableNextBtn: action.payload.enableNextBtn
            }
        };
    }

    static deleteWirelessAircraft(state, action: AsdsReduxAction) {
        return {
            payload: {
                ...state.payload,
                aircraftDetailsArray: action.payload.updatedAircraftsData,
                enableNextBtn: action.payload.enableNextBtn
            }
        }
    }
    /**
     * @param state Method to map product details from mycart page to configure product object
     * @param action
     */
    static presetMycartConfigureWireless(state, action: AsdsReduxAction) {
        let newState: any = {
            ...state,
        };
        newState.payload.enableNextBtn = false; // disabling next button - inorder accept terms and condition
        newState.payload.product.productId = action.payload.product.prodId;
        newState.payload.product.price = action.payload.product.cartList[0].unitPrice;
        newState.payload.system = action.payload.product.system;
        newState.payload.categoryName = action.payload.product.categoryName;
        newState.payload.product.attributeName = action.payload.product.attributeName;
        newState.payload.product.productName = action.payload.product.prodName;
        newState.payload.product.productDesc = action.payload.product.prodDesc;
        newState.payload.aircraftDetailsArray = action.payload.productData;

        newState.payload.editWirelessProductDetails = {
            productSeq: action.payload.product.cartList[0].prodSeq,
            seq: action.payload.product.cartList[0].seq,
            id: action.payload.product.id,
            cartSeq: action.payload.product.cartSeq
        };

        return newState;
    }
    static closeWirelessModel(state) { // show product Successfully added to cart Alert model.
        return {
            payload: {
                ...state.payload,
                configureWirelessModelOpen: false,
            }
        };
    }

    static updateWirelessData(state, action: AsdsReduxAction) {
        return {
            payload: {
                ...state.payload,
                aircraftDetailsArray: action.payload.aircraftData,
                enableNextBtn: action.payload.enableNextBtn
            }
        };
    }

    // static updateWirelessAircraftSerial(state, action: AsdsReduxAction) {
    //     return {
    //         payload: {
    //             ...state.payload,
    //             aircraftDetailsArray: action.payload.aircraftData,
    //             enableNextBtn: action.payload.enableNextBtn
    //         }
    //     };
    // }

    // static updateWirelessAircraftTail(state, action: AsdsReduxAction) {
    //     return {
    //         payload: {
    //             ...state.payload,
    //             aircraftDetailsArray: action.payload.aircraftData,
    //             enableNextBtn: action.payload.enableNextBtn
    //         }
    //     };
    // }

    static dispatchAircraftTypeInfoProcessing(state, action: AsdsReducerObject) {
        return {
            isSuccess: true,
            isFetching: false,
            payload: {
                ...state.payload,
                isAircraftTypeInfoInProgress: action.payload.isAircraftTypeInfoInProgress,
            }
        }
    }
    // static addWirelessProductToCart(state, action: AsdsReduxAction) {
    //     return {
    //         payload: {
    //             ...state.payload,
    //             productsInCart: action.payload.productsInCart,
    //         }
    //     };
    // }
    static updateAcceptTermsStatus(state, action: AsdsReduxAction) {
        return {
            payload: {
                ...state.payload,
                acceptTermsStatus: action.payload.acceptTermsStatus,
                acceptTermsErrorMsg: action.payload.acceptTermsErrorMsg,
                enableNextBtn: action.payload.enableNextBtn,
            }
        }
    }
    static getAircraftTypes(state, action: AsdsReduxAction) {
        return {
            payload: {
                ...state.payload,
                aircraftTypes: action.payload.aircraftTypes,
                aircraftTypeWirelessDeviceId: action.payload.aircraftTypeWirelessDeviceId,
            }
        };
    }
    static hideValidationErrorMsg(state, action: AsdsReduxAction) {
        return {
            payload: {
                ...state.payload,
                showValidationErrorMsg: action.payload.showValidationErrorMsg
            }
        }
    }
}

const productFeatureHandlers = {
    [ActionConstants.WIRELESS_ADD_TO_CART_MODEL]: ConfigureWirelessProductReducer.onClickWirelessAddToCartButton,
    [ActionConstants.WIRELESS_RESET_CONFIGURATION]: ConfigureWirelessProductReducer.resetWirelessConfiguration,
    [ActionConstants.WIRELESS_GOTO_CONFIRM_CONFIG]: ConfigureWirelessProductReducer.gotoWirelessConfirmConfig,
    [ActionConstants.WIRELESS_BACK_BUTTON_HANDLE]: ConfigureWirelessProductReducer.wirelessBackButtonHandle,
    [ActionConstants.WIRELESS_ADD_AIRCRAFT]: ConfigureWirelessProductReducer.addWirelessAircraft,
    [ActionConstants.WIRELESS_DELETE_AIRCRAFT]: ConfigureWirelessProductReducer.deleteWirelessAircraft,
    [ActionConstants.WIRELESS_UPDATE_AIRCRAFT_TYPE]: ConfigureWirelessProductReducer.updateWirelessData,
    [ActionConstants.WIRELESS_UPDATE_AIRCRAFT_SERIAL]: ConfigureWirelessProductReducer.updateWirelessData,
    [ActionConstants.WIRELESS_UPDATE_AIRCRAFT_TAIL]: ConfigureWirelessProductReducer.updateWirelessData,
    [ActionConstants.WIRELESS_AIRCRAFT_TYPE_PROCESSING]: ConfigureWirelessProductReducer.dispatchAircraftTypeInfoProcessing,
    [ActionConstants.PRESET_CONFIGURE_WIRELESS_MYCART]: ConfigureWirelessProductReducer.presetMycartConfigureWireless,
    [ActionConstants.CLOSE_WIRELESS_MODEL]: ConfigureWirelessProductReducer.closeWirelessModel,
    [ActionConstants.ADD_WIRELESS_PRODUCT_TO_CART]: ConfigureWirelessProductReducer.setProductsInCart,
    [ActionConstants.UPDATE_WIRELESS_ACCEPT_TERMS_STATUS]: ConfigureWirelessProductReducer.updateAcceptTermsStatus,
    [ActionConstants.GET_WIRELESS_AIRCRAFT_TYPE]: ConfigureWirelessProductReducer.getAircraftTypes,
    [ActionConstants.LOAD_CART_DATA]: ConfigureWirelessProductReducer.setProductsInCart,
    [ActionConstants.HIDE_VALIDATION_ERROR_MSG]: ConfigureWirelessProductReducer.hideValidationErrorMsg
};

const initialState = {
    payload: {
        activeTab: 1,
        enableNextBtn: false,
        configureWirelessModelOpen: false,
        acceptTermsStatus: false,
        acceptTermsErrorMsg: '',
        product: {},
        system: '',
        categoryName: '',
        productsInCart: [],
        aircraftDetailsArray: [
            {
                aircraftType: '',
                aircraftTypeError: '',
                serialNumber: '',
                serialNumberError: '',
                tailNumber: '',
                tailNumberError: '',
                price: 0.00,
            }
        ],
        aircraftTypes: [{
            value: '',
            text: '',
        }],
        aircraftTypeWirelessDeviceId: '',
        isAircraftTypeInfoInProgress: true,
        redirectTo: undefined,
        editWirelessProductDetails: {
            productSeq: 0,
            id: 0,
            seq: 0,
            cartSeq: 0
        },
        showValidationErrorMsg: true
    }
};
export const configWirelessProductData = createReducer(initialState, productFeatureHandlers);